import { Link } from "gatsby"
import PropTypes from "prop-types"
import React, { useState } from "react"



function NavBar({ siteTitle }) {

    const [isExpanded, toggleExpansion] = useState(false)

    return (
        <div className='py-8 px-8 flex flex-wrap md:flex-wrap justify-center  font-ronsof-ten'>
            <nav className="px-5 ">
                <div className="flex items-center flex-shrink-0 text-white mr-6">
                    <span className="font-semibold text-xl tracking-tight">{siteTitle}</span>
                </div>
                <div className="block lg:hidden">
                    <button onClick={() => toggleExpansion(!isExpanded)} className="flex items-center px-3 py-2 border rounded text-red-900 border-red-900 hover:text-gray-500 hover:border-gray-500">
                        <svg className="fill-current h-3 w-3" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><title>Menu</title><path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" /></svg>
                    </button>
                </div>
                <div className={`${isExpanded ? `block` : `hidden`} px-24  w-full block flex-grow lg:flex  lg:w-auto`}>

                    <div className="px-2 space-x-12 text-sm lg:flex-grow">
                        <Link to={`/`} activeStyle={{ color: 'black' }} activeClassName='active' href="#responsive-header" className="py-2 menuBarStyle block mt-4 lg:inline-block lg:mt-0  hover:text-red-900 mx-10">
                            Home
                        </Link>
                      
                        <Link to={`/pageQuemSomos`} activeStyle={{ color: 'black'}} activeClassName='active' className=" py-2 menuBarStyle block mt-4 lg:inline-block lg:mt-0  hover:text-red-900 mx-10">
                            Quem somos
                        </Link>
                        <Link to={`/pageCoaching`} activeStyle={{ color: 'black' }} activeClassName='active' className=" py-2 menuBarStyle block mt-4 lg:inline-block lg:mt-0  hover:text-red-900 mx-10">
                            Coaching
                        </Link>                        
                        <Link to={`/pageCaseDeSucesso`} activeStyle={{ color: 'black' }} activeClassName='active' className=" py-2 menuBarStyle block mt-4 lg:inline-block lg:mt-0  hover:text-red-900 mx-10">
                            Cases de sucesso
                        </Link>
                        <Link to={`/pageBlog`} activeStyle={{ color: 'black' }} activeClassName='active' className=" py-2 menuBarStyle block mt-4 lg:inline-block lg:mt-0  hover:text-red-900 mx-10">
                            Blog
                        </Link>
                        <Link to={`/pageContato`} activeStyle={{ color: 'black' }} activeClassName='active' className=" py-2 menuBarStyle block mt-4 lg:inline-block lg:mt-0 
                         hover:text-red-900 mx-10">
                            Contato
                        </Link>
                    </div>
                </div>
            </nav>
        </div>
    )
}

NavBar.propTypes = {
    siteTitle: PropTypes.string,
}

NavBar.defaultProps = {
    siteTitle: ``,
}

export default NavBar